import Vue from 'vue/dist/vue.esm.js'
import './config/api.js';
import './components/index.js';
import './directives/click-outside.js'

import IndexLong from './pages/index-long.vue';
import Index from './pages/index.vue';
import Payment from './pages/payment.vue';

if (window.location.pathname.startsWith('/pagar/')) {
  var rootComponent = Payment
} else if (window.product.long_page) {
  var rootComponent = IndexLong
} else {
  var rootComponent = Index
}

new Vue({
  el: '#app',
  extends: rootComponent,
});
